import * as theme from "./theme.css";

const LoginRightText = () => {
    return <div className={theme.loginFormRight} />;
};

export default LoginRightText;
